import { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import './ChatChallengeChampion.scss';

const ChatChallengeChampion = (props) => {
    const music = new Audio(props.music);

    // Auto-close after animation completes (e.g., 5 seconds)
    useEffect(() => {
        const timer = setTimeout(() => {
            music.pause();
            props.close();
        }, 10000);

        return () => clearTimeout(timer);
    }, []);

    // Create confetti elements
    const createConfetti = () => {
        const confettiElements = [];
        music.currentTime = 7;
        music.play();
        for (let i = 0; i < 50; i++) {
            const style = {
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                backgroundColor: ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff'][Math.floor(Math.random() * 6)]
            };
            confettiElements.push(<div key={i} className='confetti' style={style}></div>);
        }
        return confettiElements;
    };

    return (
        <div className='chat-challenge-champion'>
            <div className='confetti-container'>
                {createConfetti()}
            </div>

            <div className='champion-content'>
                <h1 className='champion-title bounce-animation'>
                    Chat Challenge Champion!
                </h1>
                
                {props.animalImage && (
                    <div className='bouncing-animal'>
                        <img 
                            src={props.animalImage} 
                            alt='Champion Animal' 
                            className='animal-image'
                        />
                    </div>
                )}

                <div className='champion-message'>
                    <p>Congratulations, {props.studentName}!</p>
                    {/* Bold and increase font size on the 100% text. */}
                    <p>You got <span style={{ fontWeight: 'bold', fontSize: '2rem' }}>100%</span> on the Chat Challenge!</p>
                </div>

                <div className='stars'>
                    <span className='star'>⭐</span>
                    <span className='star'>⭐</span>
                    <span className='star'>⭐</span>
                </div>
            </div>
        </div>
    );
};

export default ChatChallengeChampion;

